import store from '@/store'
import EventHandler from '@/utils/eventHandler'
import Message from '@/utils/message'
// import logger from '@/utils/log'

let permission = {
  inserted(el, binding, vnode) {
    // logger.info(
    //   'button inserted, permission Check >>>',
    //   binding,
    //   store.state.log.menuId
    // )
    EventHandler.once(permissionLogic, 'loaded-menu', 'loaded-permission')
    function permissionLogic() {
      const { value } = binding
      let menuId = store.state.log.menuId
      console.log('==========================================', menuId)
      let permissions = []
      let target = _.find(store.state.user.buttonPermission, {
        menu_id: menuId
      })
      if (target) {
        permissions = target.actions
      }
      if (menuId === 'notice' || menuId === 'mobileNotice') {
        permissions.push('btnSearch2')
        if (store.state.user.admin === 'true') {
          permissions.push('btnCreate2')
        }
      }
      // logger.info(
      //   'permission check :',
      //   store.state.user.buttonPermission,
      //   target,
      //   permissions,
      //   menuId
      // )

      if (value && value instanceof Array && value.length > 0) {
        const permissionPermissions = value
        const hasPermission = permissions.some(role => {
          return permissionPermissions.includes(role)
        })

        // permission이 없으면 해당 el은 삭제 되어야 한다.
        if (!hasPermission) {
          el.parentNode && el.parentNode.removeChild(el)
        }
      } else {
        // value 값이 빈 배열 값이라면 무시해도 좋다.
        if (value instanceof Array) return
        throw new Error(
          `버튼 퍼미션 설정이 필요합니다.! 예: v-permission="['btnUpdate','btnDelete']"`
        )
      }
    }
  }
}

const install = function(Vue) {
  Vue.directive('permission', permission)
}

permission.install = install
export default permission
